/*
* Store 就是把它们联系到一起的对象。Store 有以下职责：
* 维持应用的 state；
* 提供 getState() 方法获取 state；
* 提供 dispatch(action) 方法更新 state；
* 通过 subscribe(listener) 注册监听器;
* 通过 subscribe(listener) 返回的函数注销监听器。
* */
import {createStore, applyMiddleware, compose} from 'redux'
import appReducer from '../reducers/app'

const composeEnhancers =
  process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // options like actionSanitizer, stateSanitizer
    }) : compose;
    
const enhancer = composeEnhancers(
  //applyMiddleware(...middleware),
  // other store enhancers if any
);

const appStore = (initialState = {}) => createStore(
  appReducer,
  initialState,
  enhancer
);

export default appStore


// WEBPACK FOOTER //
// ./app/javascript/app/site/store/index.js